/**
 * 指定时间之后执行 callback 回调
 * @param {Function} callback 回调函数
 * @param {Number} duration 毫秒数
 * @returns {Function}
 */
export default function useTimeDispear(callback = null, duration = 5000) {
  if (!callback) return

  let _lastTime = 0
  let rafId = null

  const disappear = () => {
    if (Date.now() - _lastTime < duration) {
      rafId = window.requestAnimationFrame(disappear)
    } else {
      rafId && window.cancelAnimationFrame(rafId)
      rafId = null
      callback && callback()
    }
  }

  return () => {
    _lastTime = Date.now()
    disappear()
  }
}
